import getStore from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import getTxpSettings from 'owa-calendar-configuration/lib/utils/getTxpSettings';
import { TxpGriffinSettingsPayload } from 'owa-calendar-configuration';
import postUserSettingsAction from 'owa-calendar-configuration/lib/services/postUserSettingsAction';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import { reloadTxpSettings } from 'owa-calendar-configuration';
import TxpSettingsEntryPoint from 'owa-calendar-configuration/lib/store/schema/TxpSettingsEntryPoint';

/**
 * Action called when we save the txp options
 */
export default async function saveTxpOptionV2(): Promise<void> {
    const optionState = getStore();
    const txpSettings = getTxpSettings();

    const CreateEventsFromEmailAsPrivate = getFallbackValueIfNull(
        optionState.CreateEventsFromEmailAsPrivate,
        txpSettings.CreateEventsFromEmailAsPrivate
    );

    const settings: TxpGriffinSettingsPayload = {
        CreateEventsFromEmailAsPrivate: CreateEventsFromEmailAsPrivate,
        EntityTypeProcessorLevelSettings: {
            FlightReservation: undefined,
            FoodEstablishmentReservation: undefined,
            LodgingReservation: undefined,
            RentalCarReservation: undefined,
            ParcelDelivery: undefined,
            EventReservation: undefined,
            Invoice: undefined,
            ServiceReservation: undefined,
        },
    };

    // Push the rest of the events to the settings
    Object.keys(optionState.EntityTypeProcessorLevelSettings).map(eventType => {
        const val = getFallbackValueIfNull(
            optionState.EntityTypeProcessorLevelSettings[eventType],
            txpSettings[eventType]
        );

        settings.EntityTypeProcessorLevelSettings[eventType] = val;
    });

    postUserSettingsAction(settings, TxpSettingsEntryPoint.FullSettings).then(response => {
        if (isSuccessStatusCode(response.status)) {
            reloadTxpSettings();
        }
    });
}
